import {Injectable} from '@angular/core';
import {SecureApi} from '../core/secure.api';

@Injectable()
export class TranslationsService {
    constructor(public secureApi: SecureApi) {
    }

    get() {
        return this.secureApi.get('translations/index');
    }

    exportFile() {
        return this.secureApi.get('translations/export');
    }

    importFile(data) {
        return this.secureApi.post('translations/import', data, false);
    }

    read(id = 0) {
        return this.secureApi.get('translations/read/' + id);
    }

    generateFile() {
        return this.secureApi.get('translations/generate');
    }
}